import { apiGet } from "./apiClient";

// The single most cross-domain-reused fetch in the feature — the same GET,
// independently re-implemented in WorkflowTaskDrawer, CancelModal,
// EditDraftDrawer, SendToSuppliersModal, PaymentLinkModal,
// QuoteApprovalModal, and PriceUpdateDrawer (7 files spanning board,
// workflow-drawer, drafts, suppliers, payments, quotes, and price-drawer).
// `userId` is optional — some call sites omit it and the backend accepts
// query_pk alone.
export function fetchTaskDetail(queryPk, { userId } = {}) {
  const qs = new URLSearchParams({ query_pk: queryPk });
  if (userId != null) qs.set("user_id", userId);
  return apiGet(`/query_workflow/task/get?${qs}`)
    .then(res => (res.data?.success ? res.data.data : null))
    .catch(() => null);
}
